import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Modules / Mixins
import isResizable from '../../../../mixins/resizable';

// Models
import ProfileModel from '../../../../../models/v2/profile';

// Base
import Card from '../../../base/card';

// Related Components
import Loading from './profile/loading';
import Show from './profile/show';

class _Profile extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
  }

  state = {
    loading: true,
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { user } = this.props;
    ProfileModel
      .where({ user_id_eq: user.id })
      .perPage(1)
      .all(false)
      .then((profiles) => {
        this.setState({
          profile: profiles[0] || {},
          loading: false,
        })
      })
  }

  render() {
    const { user, isMobile } = this.props;
    const { loading, profile } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <div className='full-width-content'>
        <Card
          className={classNames('width-auto margin-bottom-30', {
            'min-height-370': isMobile,
            'min-height-180': !isMobile,
          })}
          border='thin'
        >
          <Show {...{
            user,
            profile,
          }} />
        </Card>
      </div>
    )
  }
}

export default isResizable(_Profile);